import { ChartColumnIncreasing } from "lucide-react"

export default function MySituationStartStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <span className="w-fit rounded-lg bg-primary-50 p-1.5">
          <ChartColumnIncreasing className="size-4 text-primary-500" />
        </span>
        <h1 className="text-base font-bold">Mi situación</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/my-situation-start.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Acá vas a poder ver en detalle el progreso de tu materia: las métricas, el avance por
        módulos, los objetivos que fuiste completando y los hitos importantes. Seleccioná la materia
        que te interese y empezá a analizar.
      </p>
    </section>
  )
}
